/* Noirarchy product card behavior (snippets/noir-product-card.liquid). Global and
   deferred; loaded after shrine.null.js. Shrine's <product-form> does the AJAX add,
   updates the cart count and opens the drawer; this file only adds the card parts.
   Clicks and submits are delegated on document, so cards that the theme editor
   re-renders keep working with no setup.

   Swatches   A click on [data-noir-swatch] presses it, crossfades the card's layers
              (CSS: 450ms, none under reduced motion) and sets the form's variant id,
              the price, the sold out state and ?variant= on the card links.
   Added      The card whose form was sent reads "Added" for 2.5s once Shrine
              publishes cart-update with source 'product-form' (it does so only after
              a successful add), then goes back to its label.

   API (window.Noir.card, the only global this file adds):
     Noir.card.select(cardOrChild, variantId)   picks a variant; returns true when found
     Noir.card.added(cardOrChild)               shows the "Added" label
   Event on the card: noir:card:change, detail { variantId }. */
(function () {
  'use strict';

  var Noir = (window.Noir = window.Noir || {});
  if (Noir.card && Noir.card.__ready) return;

  var CARD = '[data-noir-card]';
  var SWATCH = '[data-noir-swatch]';
  var ADDED_MS = 2500;
  var PENDING_MS = 30000;

  var pending = null;
  var hooked = false;
  var timers = typeof WeakMap === 'function' ? new WeakMap() : null;

  function cardOf(el) {
    return el && el.closest ? el.closest(CARD) : null;
  }

  function parts(card) {
    return {
      button: card.querySelector('[data-noir-add]'),
      label: card.querySelector('[data-noir-add-label]'),
      input: card.querySelector('form [name="id"]'),
      price: card.querySelector('[data-noir-price]'),
      compare: card.querySelector('[data-noir-compare]'),
      compareAmount: card.querySelector('[data-noir-compare-amount]'),
      error: card.querySelector('.product-form__error-message-wrapper')
    };
  }

  function emit(el, name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { bubbles: true, detail: detail || {} });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail || {});
    }
    el.dispatchEvent(event);
  }

  /* ---------- Button label ---------- */
  function setLabel(card, key) {
    var p = parts(card);
    if (!p.button || !p.label) return;
    var text = p.button.getAttribute('data-label-' + key);
    if (text) p.label.textContent = text;
  }

  function restLabel(card) {
    var button = parts(card).button;
    setLabel(card, button && button.disabled ? 'sold-out' : 'add');
  }

  function clearAdded(card) {
    if (timers) {
      var timer = timers.get(card);
      if (timer) window.clearTimeout(timer);
      timers.delete(card);
    }
    var button = parts(card).button;
    if (button) {
      button.classList.remove('is-added');
      button.style.minWidth = '';
    }
  }

  function added(cardOrChild) {
    var card = cardOf(cardOrChild);
    if (!card) return;
    var p = parts(card);
    if (!p.button || !p.label) return;
    clearAdded(card);
    /* Hold the width so the shorter label does not shift the row. */
    if (p.button.offsetWidth) p.button.style.minWidth = p.button.offsetWidth + 'px';
    p.button.classList.add('is-added');
    setLabel(card, 'added');
    var timer = window.setTimeout(function () {
      clearAdded(card);
      restLabel(card);
    }, ADDED_MS);
    if (timers) timers.set(card, timer);
  }

  /* ---------- Variant ---------- */
  /* Sets ?variant= on a link and keeps its other parameters and hash. */
  function withVariant(href, id) {
    var hash = '';
    var cut = href.indexOf('#');
    if (cut > -1) {
      hash = href.slice(cut);
      href = href.slice(0, cut);
    }
    cut = href.indexOf('?');
    var base = cut > -1 ? href.slice(0, cut) : href;
    var params = cut > -1 ? href.slice(cut + 1).split('&') : [];
    params = params.filter(function (pair) {
      return pair && pair.split('=')[0] !== 'variant';
    });
    params.push('variant=' + encodeURIComponent(id));
    return base + '?' + params.join('&') + hash;
  }

  function select(cardOrChild, variantId) {
    var card = cardOf(cardOrChild);
    if (!card || variantId == null) return false;
    var id = String(variantId);
    var swatches = card.querySelectorAll(SWATCH);
    var swatch = null;
    Array.prototype.forEach.call(swatches, function (button) {
      if (button.getAttribute('data-variant-id') === id) swatch = button;
    });
    if (!swatch) return false;

    Array.prototype.forEach.call(swatches, function (button) {
      button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
    });

    Array.prototype.forEach.call(card.querySelectorAll('[data-noir-layer]'), function (layer) {
      var on = layer.getAttribute('data-variant-id') === id;
      layer.classList.toggle('is-active', on);
      var img = layer.querySelector('img');
      if (img) img.setAttribute('alt', on ? layer.getAttribute('data-alt') || '' : '');
    });

    var p = parts(card);
    if (p.input) p.input.value = id;
    if (p.price && swatch.hasAttribute('data-price')) p.price.textContent = swatch.getAttribute('data-price');
    if (p.compare) {
      var compare = swatch.getAttribute('data-compare') || '';
      if (p.compareAmount) p.compareAmount.textContent = compare;
      p.compare.hidden = !compare;
    }
    if (p.error) p.error.hidden = true;

    clearAdded(card);
    if (p.button) p.button.disabled = swatch.getAttribute('data-available') !== 'true';
    restLabel(card);

    Array.prototype.forEach.call(card.querySelectorAll('[data-noir-card-link]'), function (link) {
      var href = link.getAttribute('href');
      if (href) link.setAttribute('href', withVariant(href, id));
    });

    emit(card, 'noir:card:change', { variantId: id });
    return true;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target && event.target.closest ? event.target.closest(SWATCH) : null;
    if (!swatch || !cardOf(swatch)) return;
    event.preventDefault();
    if (swatch.getAttribute('aria-pressed') === 'true') return;
    select(swatch, swatch.getAttribute('data-variant-id'));
  });

  /* ---------- Added ---------- */
  /* Capture phase, so this runs before Shrine's own submit handler on the form. A
     submit from any other form (the product page, the drawer) clears the record. */
  document.addEventListener(
    'submit',
    function (event) {
      var card = cardOf(event.target);
      pending = card ? { card: card, at: Date.now() } : null;
    },
    true
  );

  function onCartUpdate(data) {
    if (!data || data.source !== 'product-form' || !pending) return;
    var job = pending;
    pending = null;
    if (Date.now() - job.at > PENDING_MS) return;
    if (!document.documentElement.contains(job.card)) return;
    added(job.card);
  }

  /* subscribe and PUB_SUB_EVENTS are globals from shrine.null.js. */
  function hook() {
    if (hooked) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    hooked = true;
  }

  hook();
  if (!hooked) {
    document.addEventListener('DOMContentLoaded', hook);
    window.addEventListener('load', hook);
  }

  Noir.card = {
    __ready: true,
    select: select,
    added: added
  };
})();
